import React, {Component} from 'react'
import IconSVG from 'svg-inline-react'
import Carousel from 'nuka-carousel'

import './InstantBookingSpinner.scss'

class InstantBookingSpinner extends Component {
    
    render() {
        return (
            <div className="InstantBookingSpinner">
                <div className="InstantBookingSpinner-overlay">
                    <div className="InstantBookingSpinner-info">
                        <div className="InstantBookingSpinner-title">Считаем точную стоимость вашей перевозки</div>
                        <div className="InstantBookingSpinner-subTitle">
                            А пока посмотрите наш автопарк&nbsp;<span className="InstantBookingSpinner-emoji">😊</span>
                        </div>
                        <div className="InstantBookingSpinner-carousel">
                            <Carousel
                                swiping
                                autoplay
                                renderBottomCenterControls={() => {}}
                                dragging
                                wrapAround
                                renderCenterLeftControls={({previousSlide}) => (
                                    <IconSVG
                                        className="InstantBookingSpinner-iconPrev"
                                        onClick={previousSlide}
                                        src={require('!svg-inline!./leftArrow.svg')}
                                        title="Назад"/>
                                )}
                                renderCenterRightControls={({nextSlide}) => (
                                    <IconSVG
                                        className="InstantBookingSpinner-iconNext"
                                        onClick={nextSlide}
                                        src={require('!svg-inline!./rightArrow.svg')}
                                        title="Далее"/>
                                )}>
                                <img className="InstantBookingSpinner-photo"
                                     src="https://www.vezetvsem.ru/assets/images/instant-booking/1.jpg"/>
                                <img className="InstantBookingSpinner-photo"
                                     src="https://www.vezetvsem.ru/assets/images/instant-booking/2.jpg"/>
                                <img className="InstantBookingSpinner-photo"
                                     src="https://www.vezetvsem.ru/assets/images/instant-booking/3.jpg"/>
                                <img className="InstantBookingSpinner-photo"
                                     src="https://www.vezetvsem.ru/assets/images/instant-booking/4.jpg"/>
                                <img className="InstantBookingSpinner-photo"
                                     src="https://www.vezetvsem.ru/assets/images/instant-booking/5.jpg"/>
                            </Carousel>
                        </div>
                        <div className="InstantBookingSpinner-spinnerBox">
                            <IconSVG
                                className="InstantBookingSpinner-spinner"
                                src={require('!svg-inline!./spinner.svg')}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default InstantBookingSpinner



// WEBPACK FOOTER //
// ./client/components/InstantBookingSpinner/InstantBookingSpinner.js